import { IconProps } from '.';

const HammerIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 31 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={customClasses}
      {...rest}
    >
      <g id="hammer">
        <path
          id="hammer_2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.2976 0.333008C10.1036 0.333008 9.91217 0.378189 9.7386 0.464974L0.690983 4.98878C0.267503 5.20052 0 5.63335 0 6.10682V10.128C0 10.8183 0.559644 11.378 1.25 11.378H10.5556V33.2497C10.5556 33.94 11.1152 34.4997 11.8056 34.4997H18.8426C19.5329 34.4997 20.0926 33.94 20.0926 33.2497V11.378H28.8955C29.5859 11.378 30.1455 10.8183 30.1455 10.128V1.58301C30.1455 0.892652 29.5859 0.333008 28.8955 0.333008H10.2976ZM2.5 6.87936L10.5927 2.83301H21.1068V8.87798H17.5926V31.9997H13.0556V8.87798H2.5V6.87936ZM23.6068 8.87798H27.6455V2.83301H23.6068V8.87798Z"
          fill={color || '#383E31'}
        />
      </g>
    </svg>
  );
};

export default HammerIcon;
